import React from 'react';
import './style.scss';

const FrontpageCTAButtons = () => {
    return (
        <div className="container frontpage-cta-buttons__container">
            <a
                href="/internet"
                className="button frontpage-cta-buttons__button"
            >
                Bestil Internet
            </a>
            <a href="/tv" className="button frontpage-cta-buttons__button">
                Bestil Tv-pakke
            </a>
        </div>
    );
};

export default FrontpageCTAButtons;
